import React from 'react';
import LabelsCell from '@/components/table/LabelsCell';
import { formatList } from '@/utils/resultsHelper';
import { safeFormArray } from '../../state/state';

const FormObjectStringsCell = ({ field, item, options = [] }) => (
  <LabelsCell
    className={`aridhia-form-object-strings-cell-${field.type}`}
    collapsing
    labels={safeFormArray(item[field.name]).map((i) => formatList(i, options))}
  />
);

export default FormObjectStringsCell;
